import { useEffect, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import GlobalSearch from './containers/GlobalSearch'
import { locale as initialLocale } from '@/root.component'
import SmartNavbar from './components/smart-navbar/smart-navbar'
import { permissionsActions } from '@Techedge/digitalportal-shared'
import {
    importMessages,
    LocaleMessages,
    SmartlyIntlProvider,
} from './utils/localization/intlHelper'
import './App.scss'

export const App = (props: any) => {
    const [locale, setLocale] = useState<string>(initialLocale)
    const [searchVisible, setSearchVisible] = useState(false)
    const [messages, setMessages] = useState<LocaleMessages | null>(null)

    useEffect(() => {
        setLocale(initialLocale)
        moment.locale(initialLocale)
    }, [])

    useEffect(() => {
        if (props?.language && props?.dictionary) {
            setLocale(props.language)
            moment.locale(props.language)
            importMessages(props.language).then(() => {
                setMessages(props.dictionary)
            })
        }
    }, [props?.language, props?.dictionary])

    return (
        <SmartlyIntlProvider locale={locale} messages={messages}>
            <SmartNavbar
                {...props}
                openSearch={() =>
                    setSearchVisible(!searchVisible)
                }></SmartNavbar>
            {searchVisible && (
                <GlobalSearch onClose={() => setSearchVisible(false)} />
            )}
        </SmartlyIntlProvider>
    )
}

const mapStateToProps = (state: any) => ({
    token: state.userReducer.accessToken,
    language: state.userReducer.user.language,
    dictionary: state.userReducer.user.dictionary,
})

const mapDispatchToProps = (dispatch: any) => ({
    getActions: () => dispatch(permissionsActions.getActions()),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
